import DocumentTransfertPage from "./DocumentTransfertPage";

const DocumentTransfertVentePage = () => {
  return <DocumentTransfertPage mode="vente" />;
};

export default DocumentTransfertVentePage;